/**
 * claim/call 등 성능점검 응답에서 점검장(shop) ID 추출.
 * - 최상위 shopId
 * - shop 이 객체이면 shop.shopId
 * - shop 이 JSON 문자열이면 파싱 후 shopId
 * - inspector 문자열/객체 내부 shopId
 */
function getShopIdFromShopField(shop) {
  if (shop == null || shop === '') return null;
  if (typeof shop === 'string') {
    try {
      const parsed = JSON.parse(shop);
      const id = parsed?.shopId;
      return id != null && id !== '' ? id : null;
    } catch (e) {
      return null;
    }
  }
  if (typeof shop === 'object') {
    const id = shop.shopId;
    return id != null && id !== '' ? id : null;
  }
  return null;
}

export function getShopIdFromPerformanceCheckData(raw) {
  if (raw == null) return null;
  const pc = raw.performanceCheckData ?? raw;

  const direct = pc?.shopId;
  if (direct != null && direct !== '') {
    return direct;
  }

  const fromShop = getShopIdFromShopField(pc?.shop);
  if (fromShop != null) {
    return fromShop;
  }

  const rawInspector = pc?.inspector;
  if (rawInspector == null) return null;

  try {
    const ins =
      typeof rawInspector === 'string'
        ? JSON.parse(rawInspector)
        : rawInspector;
    const id = ins?.shopId;
    if (id != null && id !== '') return id;
  } catch (e) {
    return null;
  }

  return null;
}
